import type { CensusDraftWriteRequest } from "@/api/census-draft";
import { ensureCensusDraft, saveCensusDraft, submitCensusDraft } from "@/api/census-draft-client";
import { useMutation, useQuery } from "@tanstack/react-query";

/**
 * Seed-on-login read of the census draft. `ensure` is idempotent: it returns the
 * existing draft or seeds a new one from the client's operational data, so the
 * flow always pre-fills from the single source of truth (db-service).
 */
export function useCensusDraft(enabled: boolean) {
  return useQuery({
    queryKey: ["census-draft"],
    queryFn: ensureCensusDraft,
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
}

/** Best-effort autosave fired on each page advance. */
export function useSaveCensusDraft() {
  return useMutation({
    mutationFn: (body: CensusDraftWriteRequest) => saveCensusDraft(body),
  });
}

/** Final submit — flips the draft to `submitted`. */
export function useSubmitCensusDraft() {
  return useMutation({
    mutationFn: (body: CensusDraftWriteRequest) => submitCensusDraft(body),
  });
}
